export const enumKeys = <T extends Record<string, string>>(enumObject: T): (keyof T)[] => {
  return Object.keys(enumObject) as (keyof T)[];
};

export const enumValues = <T extends Record<string, string>>(enumObject: T): T[keyof T][] => {
  return Object.values(enumObject) as T[keyof T][];
};
